import axios, {} from 'axios';
import { useAuthStore } from '@/stores/auth';
const baseURL = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';
export const api = axios.create({
    baseURL,
    timeout: 30_000,
    withCredentials: true, // send/receive the HttpOnly refresh cookie
    headers: { 'Content-Type': 'application/json' },
});
api.interceptors.request.use((config) => {
    const token = useAuthStore.getState().accessToken;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    const companyId = useAuthStore.getState().activeCompanyId;
    if (companyId) {
        config.headers['X-Active-Company'] = companyId;
    }
    return config;
});
let refreshInFlight = null;
// DRF's VulcanCursorPagination wraps list responses as
//   { results: [...], page: { next, previous, page_size } }
// Most call sites do `(await api.get('/x/')).data` expecting an array, so we
// transparently unwrap paginated bodies here and stash the page cursor on a
// sidecar field for code that needs it.
api.interceptors.response.use((response) => {
    const body = response.data;
    if (body &&
        typeof body === 'object' &&
        Array.isArray(body.results) &&
        'page' in body) {
        response.pageInfo = body.page;
        response.data = body.results;
    }
    return response;
}, async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
        originalRequest._retry = true;
        refreshInFlight ??= useAuthStore.getState().refresh();
        const newToken = await refreshInFlight;
        refreshInFlight = null;
        if (newToken) {
            originalRequest.headers = originalRequest.headers ?? {};
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return api.request(originalRequest);
        }
        useAuthStore.getState().logout();
    }
    return Promise.reject(error);
});
